import { Component, OnInit } from '@angular/core';
import {NbDialogRef} from '@nebular/theme';
import {SensorsService} from '../../../shared/services/sensors.service';
import {DataService} from '../../../shared/services/data.service';
import {combineLatest} from 'rxjs';

@Component({
  selector: 'ngx-sensor-drop-init',
  templateUrl: './sensor-drop-init.component.html',
  styleUrls: ['./sensor-drop-init.component.scss'],
})
export class SensorDropInitComponent implements OnInit {

  loading = false;

  constructor(
    protected ref: NbDialogRef<SensorDropInitComponent>,
    private sensorsService: SensorsService,
    private dataService: DataService,
    ) {}

  ngOnInit() {
  }

  cancel() {
    this.ref.close();
  }

  submit() {
    this.loading = true;
    if (this.dataService.selectedSensor.id !== undefined) {
      this.sensorsService.resetInitializedSensor(this.dataService.selectedSensor.id).subscribe(
        (sensor) => {
          window.alert('Sensor ' + sensor.id + ' was successfully disassociated.');
          this.loading = false;
          this.ref.close();
        },
        error => {
          console.log(error);
          window.alert('Error: ' + error.message + ', error status: ' + error.status);
        });
    } else {
      this.ref.close();
    }
  }
}
